import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export type VoiceboxCircleLogoProps = {
  title?: string;
} & IconProps &
  React.SVGProps<SVGSVGElement>;

export const VoiceboxCircleLogo: React.VFC<VoiceboxCircleLogoProps> = ({
  size,
  title,
  ...props
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 30 30"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <circle
      cx="15"
      cy="15"
      fill="#003E51"
      r="14"
      stroke="#007FA4"
      strokeWidth="0.5"
    />
    <path
      d="M6.88466 20.9734L4.82945 14.9547C4.46759 13.897 4.92379 12.7325 5.90731 12.2005L8.8146 10.6278L11.8209 23.5173L9.744 23.2776C8.4249 23.1245 7.31302 22.2291 6.88466 20.9734Z"
      fill="#0B80A5"
    />
    <path
      d="M18.0377 14.1382C18.0872 14.299 18.1305 14.4692 18.1676 14.647C18.5542 16.4934 18.2759 18.5997 16.8207 18.9894C15.3655 19.3791 14.1098 18.2935 13.7232 16.447C13.3366 14.6006 13.8237 12.6846 15.2789 12.2949C15.9346 12.1186 16.5083 12.2052 16.9753 12.5222L18.2542 9.55615L10.168 10.266L12.95 23.3302L20.079 20.4136L19.5161 13.0758L18.0377 14.1382Z"
      fill="white"
    />
    <path
      d="M19.7461 12.9089L24.2354 12.1867C24.7766 11.449 24.8199 10.467 24.5215 9.47424L19.7461 12.9089Z"
      fill="#CADB2E"
    />
    <path
      d="M24.0271 8.32656C23.4024 7.21314 22.4018 6.20486 21.2575 5.66052L18.3486 12.4091L24.0271 8.32656Z"
      fill="#CADB2E"
    />
    <path
      d="M20.0929 5.28786C19.4325 5.17806 18.7537 5.24146 18.0918 5.53374L18.2727 9.5127L20.0929 5.28786Z"
      fill="#CADB2E"
    />
  </svg>
);
